import { cx } from "../cx";
import { DEFAULT_WORKSPACE_CURRENCY } from "./consts";
import { currencyCodeToSymbol } from "./currencyCodeToSymbol";

export const priceDisplay = (
  amountInCents: number,
  currencyCode: string,
  isCurrencyCodeHidden?: boolean,
  params?: {
    currencyClassName?: string;
    className?: string;
    isString?: boolean;
    minimumFractionDigits?: number;
    maximumFractionDigits?: number;
  } // Optional parameter for additional styling
) => {
  let { locale } = Intl.DateTimeFormat().resolvedOptions();
  if (currencyCode === "INR") {
    locale = "en-IN"; // Use Indian locale for INR
  }
  const formatter = new Intl.NumberFormat(locale, {
    style: "decimal",
    currency: currencyCode || DEFAULT_WORKSPACE_CURRENCY,
    minimumFractionDigits: params?.minimumFractionDigits ?? 2,
    maximumFractionDigits: params?.maximumFractionDigits ?? 2,
    currencyDisplay: "narrowSymbol",
  });
  const symbol =
    currencyCode && !isCurrencyCodeHidden
      ? `${currencyCodeToSymbol(currencyCode)} `
      : "";
  const formattedPrice = formatter.format(
    amountInCents !== 0 ? amountInCents / 100 : amountInCents
  );

  if (params?.isString) {
    return `${symbol}${formattedPrice}`;
  }

  return (
    <span className={params?.className}>
      {symbol && (
        <span className={cx("font-primary", params?.currencyClassName)}>
          {symbol}
        </span>
      )}
      {formatter.format(
        amountInCents !== 0 ? amountInCents / 100 : amountInCents
      )}
    </span>
  );
};
